import { Modal, Typography } from 'antd';
import type { ActionPayload } from './action-payload';

const { Paragraph, Text } = Typography;

export interface ActionConfirmModalProps {
  open: boolean;
  payload: ActionPayload | null;
  onConfirm: () => void;
  onCancel: () => void;
}

/**
 * Tier 3 — user must confirm before the server re-runs the tool with `confirmed: true`.
 */
export function ActionConfirmModal({ open, payload, onConfirm, onCancel }: ActionConfirmModalProps) {
  const summary = payload?.summary ?? (payload as { toolName?: string } | null)?.toolName;
  return (
    <Modal
      title="Confirm action"
      open={open}
      onOk={onConfirm}
      onCancel={onCancel}
      okText="Confirm and run"
      cancelText="Cancel"
      destroyOnClose
    >
      <Paragraph>
        <Text type="secondary">The assistant needs your confirmation to run a transactional tool.</Text>
      </Paragraph>
      {summary ? (
        <Paragraph>
          <Text strong>{String(summary)}</Text>
        </Paragraph>
      ) : null}
      {payload?.details && (
        <pre
          style={{
            maxHeight: 200,
            overflow: 'auto',
            fontSize: 12,
            background: '#fafafa',
            padding: 8,
            borderRadius: 4,
          }}
        >
          {JSON.stringify(payload.details, null, 2)}
        </pre>
      )}
    </Modal>
  );
}
